import {
  MoneylineTicketStepFeedline,
  MoneylineTicketStepLine,
  MoneylineTicketStepBarcode,
  LineParams,
  CreateTicketLineParam,
  LineType,
  FeedlineParam,
  BarcodeParam,
  MoneylineTicketLine,
} from 'services/moneyline/moneyline.types';

export const line = ({
  align,
  bold,
  underline,
  size,
  value,
}: LineParams): MoneylineTicketStepLine => {
  const boldCode = bold ? '1' : '0';
  const underlineCode = underline ? '1' : '0';
  const alignCode = align || 'left';
  const sizeCode = size || '1';
  return {
    action: 'line',
    attributes: [alignCode, boldCode, underlineCode, sizeCode],
    value,
  };
};

const feedline = (nbOfLines: FeedlineParam): MoneylineTicketStepFeedline => {
  return {
    action: 'feedline',
    attributes: [nbOfLines.toString()],
    value: '',
  };
};

const barCode = (codeBarValue: BarcodeParam): MoneylineTicketStepBarcode => {
  return {
    action: 'Barcode',
    attributes: [],
    value: codeBarValue,
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const lineHandler: any = {
  feedline,
  line,
  barCode,
};

export const createTicketLine = (
  type: LineType,
  params: CreateTicketLineParam,
): MoneylineTicketLine => {
  return lineHandler[type](params);
};
